import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import React from 'react';
import {
  Wrapper,
  Title,
  LeadName,
  LeadMail,
  LeadPhone,
  ButtonWhatsapp,
  Text
} from './styled';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

interface Props {
  name: string;
  email: string;
  phone: string;
  useWhatsapp?: string;
}

export const MessageConfirm: React.FC<Props> = ({
  name,
  email,
  phone,
  useWhatsapp
}) => {
  const formattedWhatsappText = isClient && `¡Hola, vi este aviso en Oportunidades Marketplace ${process.env.PATH_ROOT}${useWhatsapp},\n por favor deseo más informción`;
  return(
  <Wrapper>
    <Title>¡Tu mensaje fue enviado con éxito al anunciante!</Title>
    <Text>No pierdas tiempo y llama ahora</Text>
    <LeadName>{name}</LeadName>
    <LeadMail>
      <Icon data-name="icon-mail" fill={COLORS.BLACK_BOLD} width="20" height="20" />
      <span>{email}</span>
    </LeadMail>
    <LeadPhone href={`tel:+51${phone}`}>
      <Icon data-name="icon-contact-phone" fill={COLORS.BLACK_BOLD} width="24" height="24" />
      <span>{phone}</span>
    </LeadPhone>
    {
      useWhatsapp &&
      <ButtonWhatsapp target="_blank" href={`https://api.whatsapp.com/send?phone=51${phone}&text=${isClient && encodeURIComponent(formattedWhatsappText)}`}>
        <Icon data-name="icon-whatsapp" fill="#fff" width="24" height="24" />
        <span>Contactar por Whatsapp</span>
      </ButtonWhatsapp>
    }
  </Wrapper>
)};